export const BATTERY_LOADING = "battery/loading";
export const BATTERY_ERROR = "battery/error";
export const BATTERY_FILTERS = "battery/filters";
export const BATTERY_LIST = "battery/list";



// WEBPACK FOOTER //
// ./src/actions/scooter/battery/constants.js